import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { IconButtonProps } from 'types/icon';

const PaymentExportButton: React.FC<IconButtonProps> = ({ onClick }) => {
    return (
        <Button
            variant="contained"
            size="large"
            sx={{
                textTransform: 'none',
                width: '177px',
                height: '60px',
                borderRadius: '39px',
                padding: '0px',
            }}
            onClick={onClick}
        >
            <Box
                component={'div'}
                width={'100%'}
                height={'100%'}
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '11px',
                }}
            >
                <FileDownloadOutlinedIcon
                    sx={{ fontSize: '40px !important', color: 'inherit' }}
                />
                <Typography
                    fontSize={20}
                    component={'span'}
                    fontWeight={'bold'}
                    lineHeight={'24px'}
                >
                    Xuất
                </Typography>
            </Box>
        </Button>
    );
};

export default PaymentExportButton;
